import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { showMessage, log } from '../../config/utils';

export function updateBotBuilderState(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_BOT_BUILDER_STATE,
            payload,
            path
        });
    };
}

export function deleteBotBuilderState(path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.DELETE_BOT_BUILDER_STATE,
            path
        });
    };
}

export function getPreemptiveData() {
    return function (dispatch) {
        API.getPreemptiveData({}, (error, response) => {
            log('preemptive data:', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.PREEMPTIVE_DATA_LOADED,
                    payload: response,
                });
            } else {
                showMessage('error', response && response.message ? response.message : 'unable to fetch preemptive data..');
            }
        });
    };
}

export function getWorkFlowData(payload) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORK_FLOW_LOADING,
        });

        API.getWorkFlowData(payload, (error, response) => {
            log('get workflow data response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.WORK_FLOW_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.WORK_FLOW_ERROR,
                });
            }
        });
    };
}

export function deleteWorkflow(payload) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "workflow deleting"
        });

        API.deleteWorkflow(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });
            log('delete workflow response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.WORK_FLOW_DELETED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow successfully deleted');
            } else {
                showMessage('error', response && response.message ? response.message : 'deletion failed due to some error.');
            }
        });
    };
}

export function updateWorkflow(payload) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "workflow updating"
        });

        API.updateWorkflow(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });
            log('update workflow response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.WORK_FLOW_UPDATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow  successfully updated');
            } else {
                showMessage('error', response && response.message ? response.message : 'updation failed due to some error.');
            }
        });
    };
}

export function createWorkflow(payload) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "new workflow creating"
        });

        API.createWorkflow(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });

            log('create workflow response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.WORK_FLOW_CREATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow successfully created');
            } else {
                showMessage('error', response && response.message ? response.message : 'can not create new workflow.some error occured.');
            }
        });
    };
}

export function getWorkflowModel(payload) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORK_FLOW_MODEL_LOADING,
        });

        API.getWorkflowModel(payload, (error, response) => {
            log('get workflow model response', response);
            if (!error && response && response.UIRepresentation) {
                dispatch({
                    type: actionTypes.WORK_FLOW_MODEL_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.WORK_FLOW_MODEL_ERROR,
                });
                showMessage('error', response && response.message ? response.message : 'can not fetch workflow modal. some error occured.');
            }
        });
    };
}

export function resetWorkflowModel() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.RESET_WORK_FLOW_MODEL,
        });
    };
}

export function updateWorkflowModel(payload) {
    return function (dispatch) {
        log('model update payload:', payload)
        dispatch({
            type: actionTypes.UPDATE_WORK_FLOW_MODEL,
            payload
        });
    };
}

export function saveWorkflowDiagram(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "workflow diagram saving"
        });

        API.saveWorkflowDiagram(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });

            log('save workflow diagram response', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.WORK_FLOW_DIAGRAM_SAVED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow diagram updated');
                if (callback) callback();
            } else {
                showMessage('error', response && response.message ? response.message : 'can not save workflow diagram. some error has been occured.');
            }
        });
    };
}

export function getWorkflowNodeDetails(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "Node detail fetching"
        });

        API.getWorkflowNodeDetails(payload, (error, response) => {
            dispatch({
                type: PAGE_LOADED,
            });

            log('workflow node details:', response);
            if (!error && response && response.nodeDetails) {
                dispatch({
                    type: actionTypes.WORK_FLOW_NODE_DETAILS_LOADED,
                    payload: response,
                });
                if (callback) callback();
            } else {
                showMessage('error', response && response.message ? response.message : 'can not fetch workflow node details.');
            }
        });
    };
}

export function clearWorkflowNodeDetails() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.CLEAR_WORK_FLOW_NODE_DETAILS,
        });
    };
}

export function createEntityTypeNode(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORKFLOW_DIAGRAM_NODE_CHANGING,
        });

        API.createEntityTypeNode(payload, (error, response) => {
            log('entity node creation response', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.ENTITY_TYPE_NODE_CREATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'entity node has been successfully created');
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.WORKFLOW_DIAGRAM_NODE_ERROR,
                });
                showMessage('error', response && response.message ? response.message : 'can not create entity node.');
            }
        });
    };
}

export function updateEntityTypeNode(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORKFLOW_DIAGRAM_NODE_CHANGING
        });

        API.updateEntityTypeNode(payload, (error, response) => {
            log('entity node update response:', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.ENTITY_TYPE_NODE_UPDATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow node has been successfully updated');
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.WORKFLOW_DIAGRAM_NODE_ERROR
                });
                showMessage('error', response && response.message ? response.message : 'can not update workflow node.');
            }
        });
    };
}

export function createWorkflowTypeNode(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORKFLOW_DIAGRAM_NODE_CHANGING,
        });

        API.createWorkflowTypeNode(payload, (error, response) => {
            log('create workflowTypeNode response', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.WORKFLOW_TYPE_NODE_CREATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow node has been successfully created');
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.WORKFLOW_DIAGRAM_NODE_ERROR,
                });
                showMessage('error', response && response.message ? response.message : 'can not create workflow node.');
            }
        });
    };
}

export function updateWorkflowTypeNode(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.WORKFLOW_DIAGRAM_NODE_CHANGING,
        });

        API.updateWorkflowTypeNode(payload, (error, response) => {
            log('workflow node update response', response);
            if (!error && response) {
                dispatch({
                    type: actionTypes.WORKFLOW_TYPE_NODE_UPDATED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'workflow node has been successfully updated');
                if (callback) callback();
            } else {
                dispatch({
                    type: actionTypes.WORKFLOW_DIAGRAM_NODE_ERROR,
                });
                showMessage('error', response && response.message ? response.message : 'can not update workflow node.');
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/botbuilder_details/actions.js